import { fetchData } from '@/utils/fetch'

export const retrieveFeaturedList = (data, options) => {
  return fetchData('/appb/b2b/product/featured/productList/v2', {
    method: 'post',
    body: JSON.stringify(data),
    ...options
  })
}
